/**
 * StreamNodeDTO entity class
 */

/**
 * StreamNodeDTOFactory
 * returns StreamNodeDTO entity class
 *
 * @class StreamNodeDTOFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.StreamNodeDTO} class
 *
 * @ngdoc factory
 * @name mwApp.factory:StreamNodeDTOFactory
 */
/* @ngInject */
export default function StreamNodeDTOFactory (Entity) {
  /* === StreamNodeDTO class === */

  /**
   * StreamNodeDTO model
   *
   * @class StreamNodeDTO
   * @classdesc StreamNodeDTO model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing StreamNodeDTO entity fields
   * @return {models.StreamNodeDTO} StreamNodeDTO entity
   */
  function StreamNodeDTO () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  StreamNodeDTO.prototype = Object.create(Entity.prototype)
  StreamNodeDTO.prototype.constructor = StreamNodeDTO

  /* === StreamNodeDTO instance methods & fields === */

  Object.assign(StreamNodeDTO.prototype, {

    /**
     * instance fields
     *
     * @memberof models.StreamNodeDTO#
     * @type {Object}
     */
    _fields: {
      nodeId: String,
      name: String
    }
  })

  /**/

  /* === StreamNodeDTO static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(StreamNodeDTO, Entity)
  StreamNodeDTO._name = 'StreamNodeDTO'
  StreamNodeDTO.init()

  return StreamNodeDTO
}
